import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { nowBatchConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';
import { NowSubScreen } from '@v2/pages/machines/common/enums';
import { LevelSubScreen } from '@v2/pages/common/enums';

const BatchStack = createStackNavigator();

const BatchNavigator = () => {
  return (
    <BatchStack.Navigator initialRouteName={`${NowSubScreen.BATCH}${LevelSubScreen.GENERAL}`} screenOptions={NAVIGATION_CONFIG}>
      {nowBatchConfig.map(({ Component, name }) => (
        <BatchStack.Screen key={name} name={name} component={Component} />
      ))}
    </BatchStack.Navigator>
  );
};

export { BatchNavigator };
